import youtube from "../assets/images/socialIcons/youtube.webp";
import tiktok from "../assets/images/socialIcons/tiktok.webp";
import facebook from "../assets/images/socialIcons/facebook.webp";
import { VideoGalleryCom } from "../components/gallery/GalleryComponent";
import BreadcrumbsComponent from "../components/common/BreadcrumbsComponent";

import Gallery from "../assets/images/bannerImage/gallery.webp";


interface SocialMedias {
  id: number;
  name: string;
  url: string;
  image: any;
}

const socialMedias: SocialMedias[] = [
  {
    id: 1,
    name: "YouTube",
    url: "https://www.youtube.com/@ceylonhospital",
    image: youtube,
  },
  {
    id: 2,
    name: "TikTok",
    url: "https://www.tiktok.com/@ceylonhospital",
    image: tiktok,
  },
  {
    id: 3,
    name: "Facebook",
    url: "https://www.facebook.com/CeylonHospital",
    image: facebook,
  },
];

const BreadCrumbsPath = [
  {
    id: 1,
    pathName: "Gallery",
    pathLink: "/gallery",
  },
];

 const GalleryPage = () => {
  return (
    <>
    <div className="mt-20 xl:mt-0 hidden md:block">
            <div className="flex mb-2 items-center justify-center">
              <img
                src={Gallery}
                alt="Ceylon Hospital Banner"
                width={1200}
                height={630}
                loading="eager"
                className="w-full  max-w-8xl"
                decoding="async"
                style={{
                  height: "auto",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

      <BreadcrumbsComponent breadCrumbsPath={BreadCrumbsPath} />
      <div className="">
        <div className=" ">
          {/* <TitleComponent Title={"Gallery"} Subtitle={"Gallery Section"} /> */}

          <div className="mb-5 mt-7">
            <VideoGalleryCom />
            <div className="flex flex-row gap-2 lg:gap-6 items-center justify-center mt-4">
              {/* Card Design ----------------------------------- */}

              {socialMedias.map((item) => {
                return (
                  <a
                    key={item.id}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white lg:h-44 w-52 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
                  >
                    <div className="flex flex-col gap-3 p-4 items-center justify-center  Blinker-SemiBold">
                      <div className="w-8/12">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="w-full"
                        />
                      </div>
                      <div className="w-4/1">
                        <p className=" text-gray-700 Blinker-Bold">
                          {item.name}
                        </p>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>

          {/* Sample YouTube Videos Grid */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {sampleVideos.map((video, index) => (
            <div key={index} className="aspect-w-16 aspect-h-9">
              <iframe
                src={video}
                title={`Sample Video ${index + 1}`}
                allowFullScreen
                className="w-full h-64 rounded-lg shadow-md"
              ></iframe>
            </div>
          ))}
        </div> */}
        </div>
      </div>
    </>
  );
};
export default GalleryPage;